import { render } from "./ConfirmationOverlay.vue?vue&type=template&id=63ea034a"
import script from "./ConfirmationOverlay.vue?vue&type=script&lang=js"
export * from "./ConfirmationOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__